import axios from '@axios'

export default {
  async getReport(params) {
    return axios.get('/Autoeficacia/report', { params }).then(res => res.data)
  },
}
